import React,{useState,useEffect} from 'react';
import{MenuItem,FormControl,Select,Card,CardContent} from "@material-ui/core";
import InfoBox from './InfoBox';
import Map from './Map';
import Table from "./Table";
import {sortData, prettyPrintStat} from "./util.js";
import LineGraph from "./LineGraph";
import "leaflet/dist/leaflet.css";
import './App.css';

function App() {
  const[countries, setCountries] = useState([]);
  const[country, setCountry] = useState('worldwide');
  const[countryInfo,setCountryInfo] = useState({});
  const[tableData,setTableData] = useState([]);
  const[mapCenter,setMapCenter] = useState({ lat: 34.80746 , lng: -40.4796});
  const[mapZoom,setMapZoom] = useState(3);
  const[mapCountries,setMapCountries] = useState([]);
  const[casesType, setCasesType] = useState("cases");
  useEffect(()=>{
     fetch("https://disease.sh/v3/covid-19/all")
    .then((response) => response.json())
    .then((data) => {
      setCountryInfo(data);
    });
  },[]);
  // STATE= How to write a veriable in REACT <<<<<<<<
  // useEffect= Runs a piece of code based on a given condition
  // https://disease.sh/v3/covid-19/countries
  useEffect(() =>{
    // The code inside here will run once when the component loads and not again after
    // async -> send a request, wait for it, do something with info  
    
    const getCountriesData = async () => {
      await fetch("https://disease.sh/v3/covid-19/countries")
      .then((response) => response.json())
      .then((data) =>{

        // [item1,item2,item3]
        // // -->> item1 ... -> returning an object in a shape
        // // -->> item2 ... -> returning an object in a shape
        // // -->> item3 ... -> returning an object in a shape
        // map returns the modified array based on the map function

        const countries = data.map((country) => (
          {
            name: country.country,  // United States,Pakistan
            value: country.countryInfo.iso2 //USA,UK,PAK
          }));

          const sortedData = sortData(data);
          setTableData(sortedData);
          setMapCountries(data);
          setCountries(countries);
      });
    };
    getCountriesData();
  }, []);

  const onCountryChange = async(event) =>{
    const countryCode = event.target.value; 
    setCountry(countryCode);

    const url = countryCode === 'worldwide' ? 'https://disease.sh/v3/covid-19/all':`https://disease.sh/v3/covid-19/countries/${countryCode}`;

    await fetch(url)
    .then((response) => response.json())
    .then((data) =>{
      setCountry(countryCode);
      // All of the data from country response
      setCountryInfo(data);

      setMapCenter([data.countryInfo.lat,data.countryInfo.long]);
      setMapZoom(4);

    });

    // https://disease.sh/v3/covid-19/all
    // https://disease.sh/v3/covid-19/countries/[COUNTRY_CODE]
  };
  //console.log("Country Info >>>>>",countryInfo);

  return (
    
    <div className="app">  
      <div className="app__left">
        <div className="app__header">
          <h1>COVID-19 TRACKER</h1>
          <FormControl className="app__dropdown">
            <Select
              varient="outlined" onChange ={onCountryChange} value={country}>
              {/* Loop through all the countries and show dropdown list of those countries */}
                <MenuItem value="worldwide">Worldwide</MenuItem>
              {
                countries.map(country => (
                  
                  <MenuItem value={country.value}>{country.name}</MenuItem>
                ))
              }
            </Select>
          </FormControl>
        </div>
              
        <div className="app__stats">
          {/* Infoboxes title="Coronavirus cases"*/}
          <InfoBox
            isRed
            active={casesType === "cases"}
            onClick={ (e) => setCasesType('cases')}   
            title="Coronavirus cases" 
            cases={prettyPrintStat(countryInfo.todayCases)} 
            total={prettyPrintStat(countryInfo.cases)}/>

          {/* Infoboxes title="Coronavirus recovries"*/}
          <InfoBox
            active={casesType === "recovered"}
            onClick={ (e) => setCasesType('recovered')}  
            title="Recovered" 
            cases={prettyPrintStat(countryInfo.todayRecovered)} 
            total={prettyPrintStat(countryInfo.recovered)}/>

          {/* Infoboxes title="Coronavirus deaths"*/}
          <InfoBox
            isRed
            active={casesType === "deaths"}
            onClick={ (e) => setCasesType('deaths')}  
            title="Deaths" 
            cases={prettyPrintStat(countryInfo.todayDeaths)} 
            total={prettyPrintStat(countryInfo.deaths)}/> 
        </div>
       
        {/* Map */}
        <Map casesType={casesType} countries={mapCountries} center={mapCenter} zoom={mapZoom}/>
      </div>
      <Card className="app__right">
        <CardContent>
          {/* Table */}
          <h3>Live Cases By Country </h3>
          <Table countries={tableData}/>
          {/* Graph */}
          <h3 className="app__graphtitle">Worldwide New {casesType}</h3>
          <LineGraph className="app__graph" casesType={casesType}/>
        </CardContent>
      </Card>
    </div>
    

  );
}

export default App;
